import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-verification',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <section class="verify-page">
      <div class="card">
        <h1>Email verification</h1>

        <p *ngIf="state === 'loading'">Verifying your account...</p>

        <div *ngIf="state === 'success'" class="success">
          <p>Your account has been verified successfully.</p>
          <p>You can continue to sign in.</p>
          <a class="btn primary" routerLink="/login">Go to login</a>
        </div>

        <div *ngIf="state === 'error'" class="error">
          <p>{{ errorMessage }}</p>
          <a class="btn ghost" routerLink="/register">Back to registration</a>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .verify-page { display:flex; justify-content:center; }
    .card { max-width: 520px; width:100%; background:#fff; border-radius:16px; padding:2rem; box-shadow:0 8px 24px rgba(15,23,42,.08); }
    .success { color:#166534; }
    .error { color:#b91c1c; }
    .btn { display:inline-flex; align-items:center; justify-content:center; padding:.8rem 1.2rem; border-radius:10px; text-decoration:none; margin-top:1rem; }
    .primary { background:#0f172a; color:#fff; }
    .ghost { background:#e2e8f0; color:#0f172a; }
  `],
})
export class VerificationComponent implements OnInit {
  state: 'loading' | 'success' | 'error' = 'loading';
  errorMessage = 'Verification failed.';

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    console.log('VerificationComponent loaded');
    const id = this.route.snapshot.paramMap.get('id');
    const code = this.route.snapshot.paramMap.get('code');

    if (!id || !code) {
      this.state = 'error';
      this.errorMessage = 'Verification link is incomplete.';
      return;
    }

    this.auth.verifyCustomer(id, code).subscribe({
      next: () => this.state = 'success',
      error: (error) => {
        this.state = 'error';
        this.errorMessage = error?.error?.message ?? 'Verification failed. The link may be invalid or already used.';
      },
    });
  }
}
